import s from './Workflow.module.css';

/* Mini product mock-ups shown inside the "What you get" cards.
   Pure presentational markup — product-UI sample data, not page copy. */

const RED = '#DC2626';
const GREEN = '#16A34A';
const AMBER = '#D97706';

function Line({ w, color = 'rgba(13,27,62,0.1)' }) {
  return <span className={s.bar} style={{ width: w, background: color }} />;
}

/* 1 · Alert the right people */
export function AlertMock() {
  const routes = [
    ['Social care', 'SLACK'],
    ['Regional head', 'EMAIL'],
    ['Brand desk', 'TEAMS'],
  ];
  return (
    <div className={s.mock}>
      <div className={s.mockLabel}>Routed in 12s</div>
      <div className={s.mockBody} style={{ justifyContent: 'center' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '78px 22px minmax(0,1fr)', alignItems: 'center' }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
            <div style={{ width: 52, height: 52, borderRadius: 14, background: '#EAF6FF', border: '1px solid #BFE3FF', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span style={{ width: 14, height: 14, borderRadius: 99, background: 'var(--brand)', boxShadow: '0 0 0 5px rgba(0,152,255,0.18)' }} />
            </div>
            <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--brand-deep)', textAlign: 'center', lineHeight: 1.3 }}>
              Reputation<br />alert
            </div>
          </div>
          <div style={{ alignSelf: 'stretch', position: 'relative' }} aria-hidden="true">
            <span style={{ position: 'absolute', left: 0, top: '16%', bottom: '16%', width: 1, background: '#9fd4ff' }} />
            {['16%', '50%', '84%'].map((top) => (
              <span key={top} style={{ position: 'absolute', left: 0, top, width: '100%', height: 1, background: '#9fd4ff' }} />
            ))}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {routes.map(([who, via]) => (
              <div key={who} className={s.row}>
                <span>{who}</span>
                <span className={s.tag}>{via}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className={s.mockFoot}>
        <b>P1</b>
        <span>priority set automatically</span>
      </div>
    </div>
  );
}

/* 2 · Moderate & protect */
export function ModerateMock() {
  return (
    <div className={s.mock}>
      <div className={s.mockLabel}>Owned channel feed</div>
      <div className={s.mockBody}>
        <div style={{ position: 'relative', padding: '10px 12px', borderRadius: 11, background: '#FFF6F6', border: '1px solid rgba(220,38,38,0.18)', overflow: 'hidden' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
            <span style={{ width: 16, height: 16, borderRadius: 99, background: 'rgba(220,38,38,0.18)' }} />
            <span style={{ fontSize: 11, fontWeight: 700, color: RED }}>Toxic · 0.94</span>
          </div>
          <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 5 }}>
            <Line w="88%" color="rgba(220,38,38,0.2)" />
            <Line w="62%" color="rgba(220,38,38,0.2)" />
          </div>
          <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,246,246,0.72)' }}>
            <span style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: RED, padding: '4px 10px', borderRadius: 99, background: '#fff', border: '1px solid rgba(220,38,38,0.25)' }}>Hidden</span>
          </div>
        </div>
        <div style={{ padding: '10px 12px', borderRadius: 11, background: '#F8F9FB', border: '1px solid rgba(13,27,62,0.07)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, fontWeight: 700, color: '#8A96AC' }}>
            <span>Spam / bot reply</span>
            <span>DELETED</span>
          </div>
          <div style={{ marginTop: 8 }}><Line w="74%" /></div>
        </div>
        <div style={{ padding: '10px 12px', borderRadius: 11, background: '#F2FAF5', border: '1px solid rgba(22,163,74,0.2)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, fontWeight: 700, color: GREEN }}>
            <span>Genuine complaint</span>
            <span>KEPT</span>
          </div>
          <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 5 }}>
            <Line w="92%" color="rgba(22,163,74,0.22)" />
            <Line w="55%" color="rgba(22,163,74,0.22)" />
          </div>
        </div>
      </div>
      <div className={s.mockFoot}>
        <b>0</b>
        <span>humans in the loop</span>
      </div>
    </div>
  );
}

/* 3 · Engage & resolve */
export function EngageMock() {
  return (
    <div className={s.mock}>
      <div className={s.mockLabel}>ResponseGenie™ thread</div>
      <div className={s.mockBody} style={{ justifyContent: 'center' }}>
        <div style={{ maxWidth: '84%', padding: '9px 12px', borderRadius: '12px 12px 12px 3px', background: '#F5F7FA', border: '1px solid rgba(13,27,62,0.07)', fontSize: 12, lineHeight: 1.5, color: 'var(--text-body)' }}>
          Order still hasn&apos;t shipped. Third time asking.
        </div>
        <div style={{ alignSelf: 'flex-end', maxWidth: '88%', padding: '9px 12px', borderRadius: '12px 12px 3px 12px', background: 'var(--brand)', fontSize: 12, lineHeight: 1.5, color: '#fff' }}>
          We&apos;ve located it and upgraded your delivery. Tracking is on its way.
        </div>
        <div style={{ alignSelf: 'flex-end', display: 'flex', gap: 5 }}>
          <span className={s.chip}>TAGGED</span>
          <span className={s.chip}>CRM SYNCED</span>
        </div>
      </div>
      <div className={s.mockFoot} style={{ gap: 12, paddingTop: 10, borderTop: '1px solid rgba(13,27,62,0.07)' }}>
        <span style={{ width: 44, height: 44, borderRadius: 99, background: 'conic-gradient(var(--brand) 0 80%, rgba(13,27,62,0.1) 80% 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <span style={{ width: 32, height: 32, borderRadius: 99, background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 800, color: 'var(--brand-deep)' }}>80%</span>
        </span>
        <span>closed without<br />an agent</span>
      </div>
    </div>
  );
}

/* 4 · Triggers for every moment */
export function TriggerMock() {
  const items = [
    ['New mention', 'LIVE', true],
    ['Listening spike', '+318%'],
    ['Influential voice', '3.1M'],
    ['SLA breach', '2M LEFT'],
    ['Form submitted', 'AUTO'],
  ];
  return (
    <div className={s.mock}>
      <div className={s.mockLabel}>Live trigger stream</div>
      <div className={s.mockBody} style={{ gap: 0, justifyContent: 'space-between' }}>
        {items.map(([label, badge, live], i) => (
          <div key={label} style={{ display: 'grid', gridTemplateColumns: '16px minmax(0,1fr)', gap: 10, alignItems: 'center', position: 'relative' }}>
            <div style={{ display: 'flex', justifyContent: 'center', alignSelf: 'stretch', position: 'relative', alignItems: 'center' }}>
              {i < items.length - 1 && <span style={{ position: 'absolute', top: '50%', bottom: '-50%', width: 1, background: '#bfe3ff' }} />}
              <span style={{ width: 10, height: 10, borderRadius: 99, background: live ? 'var(--brand)' : '#fff', border: '2px solid var(--brand)', boxShadow: live ? '0 0 0 4px rgba(0,152,255,0.16)' : 'none', position: 'relative' }} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, padding: '8px 0' }}>
              <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--brand-deep)' }}>{label}</span>
              <span className={s.chip}>{badge}</span>
            </div>
          </div>
        ))}
      </div>
      <div className={s.mockFoot}>
        <b>24/7</b>
        <span>social &amp; support, always armed</span>
      </div>
    </div>
  );
}

/* 5 · Filters that understand meaning */
export function FilterMock() {
  const pill = { fontSize: 11, fontWeight: 600, color: 'var(--brand-deep)', padding: '3px 9px', borderRadius: 99, background: '#fff', border: '1px solid rgba(13,27,62,0.1)' };
  const divider = (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} aria-hidden="true">
      <span style={{ height: 1, flex: 1, background: 'rgba(13,27,62,0.09)' }} />
      <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: '0.1em', color: '#8A96AC' }}>AND</span>
      <span style={{ height: 1, flex: 1, background: 'rgba(13,27,62,0.09)' }} />
    </div>
  );
  const meter = (label, pct, color, val) => (
    <>
      <span style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-body)' }}>{label}</span>
      <span style={{ height: 6, borderRadius: 99, background: 'rgba(13,27,62,0.08)', position: 'relative', display: 'block' }}>
        <span style={{ position: 'absolute', top: 0, bottom: 0, left: 0, width: `${pct}%`, borderRadius: 99, background: color }} />
      </span>
      <span style={{ fontSize: 11, fontWeight: 700, color: 'var(--brand-deep)', textAlign: 'right' }}>{val}</span>
    </>
  );
  return (
    <div className={s.mock}>
      <div className={s.mockLabel}>Filter builder</div>
      <div className={s.mockBody}>
        <div style={{ padding: '10px 12px', borderRadius: 11, background: '#F5F9FF', border: '1px solid #BFE3FF' }}>
          <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.08em', color: 'var(--brand)' }}>CONTEXTUALPULSE™ ASPECT</div>
          <div style={{ marginTop: 8, display: 'flex', flexWrap: 'wrap', gap: 5 }}>
            <span style={pill}>delivery</span>
            <span style={pill}>billing</span>
            <span style={{ ...pill, color: RED, background: '#FFF6F6', border: '1px solid rgba(220,38,38,0.2)' }}>negative</span>
          </div>
        </div>
        {divider}
        <div style={{ padding: '10px 12px', borderRadius: 11, background: '#F7FAFF', border: '1px solid rgba(13,27,62,0.08)' }}>
          <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.08em', color: '#8A96AC' }}>EMOTION</div>
          <div style={{ marginTop: 8, display: 'grid', gridTemplateColumns: '66px minmax(0,1fr) 30px', alignItems: 'center', gap: 8, rowGap: 7 }}>
            {meter('Frustration', 54, RED, '54%')}
            {meter('Urgency', 31, AMBER, '31%')}
          </div>
        </div>
        {divider}
        <div className={s.row} style={{ background: '#F7FAFF' }}>
          <span>SignalSense™ churn risk</span>
          <span className={s.tag}>HIGH</span>
        </div>
      </div>
    </div>
  );
}

/* 6 · Sequence, branch & parallelise */
export function BranchMock() {
  const node = { padding: '9px 11px', borderRadius: 11, background: '#F7FAFF', border: '1px solid rgba(13,27,62,0.08)' };
  const stem = (
    <div style={{ height: 14, display: 'flex', justifyContent: 'center' }} aria-hidden="true">
      <span style={{ width: 1, background: '#9fd4ff' }} />
    </div>
  );
  return (
    <div className={s.mock}>
      <div className={s.mockLabel}>Branching playbook</div>
      <div className={s.mockBody} style={{ gap: 0, justifyContent: 'space-between' }}>
        <div style={{ padding: '9px 12px', borderRadius: 11, background: '#EAF6FF', border: '1px solid #BFE3FF', fontSize: 12, fontWeight: 700, color: 'var(--brand)' }}>
          Trigger · negative spike
        </div>
        {stem}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0,1fr))', gap: 10 }}>
          <div style={node}>
            <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--brand-deep)' }}>If churn risk</div>
            <div style={{ marginTop: 3, fontSize: 11, color: '#6B7280' }}>→ escalate P1</div>
          </div>
          <div style={node}>
            <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--brand-deep)' }}>If buying intent</div>
            <div style={{ marginTop: 3, fontSize: 11, color: '#6B7280' }}>→ route to sales</div>
          </div>
        </div>
        {stem}
        <div style={{ display: 'flex', gap: 6 }}>
          {['Reply', 'Tag', 'Notify'].map((a) => (
            <span key={a} style={{ flex: 1, padding: '8px 6px', borderRadius: 10, background: '#F5F9FF', border: '1px solid rgba(13,27,62,0.07)', fontSize: 11, fontWeight: 600, color: 'var(--brand-deep)', textAlign: 'center' }}>{a}</span>
          ))}
        </div>
        {stem}
        <div style={{ padding: '9px 12px', borderRadius: 11, background: '#F0FAF3', border: '1px solid rgba(22,163,74,0.22)', fontSize: 12, fontWeight: 700, color: GREEN }}>
          Chain complete · no code
        </div>
      </div>
    </div>
  );
}
